export {
  default as PayerTypeComponent,
  renderPayerTypeComponent,
} from './PayerTypeComponent';
export * from './config';
